import HTTP from '@/utils/http'
const http = new HTTP()

/**
 * @description 商品列表数据
 * @see https://yapi.dayuan1997.com/project/95/interface/api/10771
 *
 */
export function apiGetProducts() {
  return http.get({
    url: '/mall/product/index',
  })
}

/**
 * @description 购买商品
 * @see https://yapi.dayuan1997.com/project/95/interface/api/10776
 *
 */
export function apiBuyProduct(data) {
  return http.post({
    url: '/mall/user/buy',
    data: {
        productId: data.productId,
        num: data.num,
    }
  })
}

/** 获取用户收到的礼物
 * @description 
 * @see https://yapi.dayuan1997.com/project/95/interface/api/10781
 *
 */
export function apiGetReceivedGifts(userId) {
  return http.get({
    url: '/mall/user/gift',
    params: {
      userId,
    }
  })
}

/** 获取用户资产列表
 * @description 
 * @see https://yapi.dayuan1997.com/project/95/interface/api/10786
 *
 */
export function apiGetUserAssets() {
  return http.get({
    url: '/mall/user/asset',
  })
}

/** 道具使用通用接口
 * @description 
 * @see https://yapi.dayuan1997.com/project/95/interface/api/10791
 *
 */
export function apiUseAsset(data) {
  return http.post({
    url: '/mall/prop/user/use',
    data,
  })
}

/** 个人信息
 * @description 
 * @see https://yapi.dayuan1997.com/project/95/interface/api/10791
 *
 */
export function apiGetMallUserInfo(params) {
  return http.get({
    url: '/mall/user/info',
    params,
  })
}

// 用户物品使用记录
export function apiGetUserUseRecord(data) {
  return http.get({
    url: '/mall/user/use/list',
    params: data,
  })
}
